<header class="top-0 left-0 z-[120] sticky shadow-gray-300 shadow-md" id="app-header">
    <nav class="bg-green-500 shadow-md border-b-[4px] border-b-green-300">
        <div class="mx-auto px-4 sm:px-6 lg:px-6">
            <div class="flex justify-between items-center h-16">
                <div class="flex items-center">
                    <div class="shrink-0">
                        <a
                            [class.cursor-pointer]="!isRestrictedForeman()"
                            (click)="goTo('/reports')"
                            tabindex="0"
                            (keyup.enter)="goTo('/reports')"
                        >
                            <img class="h-14" src="/favicon.svg" alt="Isl Labour Tracking and Reporting" />
                        </a>
                    </div>
                    <div class="ml-2 lg:ml-6">
                        <h1 class="text-white md:text-md lg:text-md text-sm xl:text-xl">
                            Labour Tracking and Reporting
                        </h1>
                        <p-select
                            [options]="selectOptions()"
                            optionLabel="label"
                            optionValue="value"
                            class="w-full md:w-56"
                            (onChange)="changeOption($event)"
                            [style]="{ background: 'transparent', border: 'none', width: '120px' }"
                            class="select-city"
                            tabindex="0"
                            [(ngModel)]="city"
                        />
                    </div>
                    <div class="hidden lg:block">
                        <div class="flex items-baseline space-x-1 lg:space-x-2 ml-2 lg:ml-8">
                            @for (option of menu(); let index = $index; track $index) {
                                <a
                                    [tabindex]="index + 2"
                                    (click)="goTo(option.routerLink)"
                                    (keyup.enter)="goTo(option.routerLink)"
                                    class="relative flex items-center gap-2 hover:bg-green-700 px-3 py-2 rounded-sm font-bold !text-[14px] text-white lg:text-md xl:text-lg uppercase cursor-pointer"
                                    [ngClass]="{
                                        'bg-green-700 ': option.state && option.state['active'] === true
                                    }"
                                >
                                    <i class="opacity-60 material-icons">{{ option.icon }}</i>
                                    {{ option.label }}

                                    @if (option.state && option.state['hasBadge']) {
                                        <span
                                            class="items-center grid bg-green-400 opacity-70 px-2 rounded-xl h-5 text-white text-xs text-center"
                                        >
                                            {{ option.state['badgeCount'] }}
                                        </span>
                                    }
                                    @if (option.state && option.state['active']) {
                                        <div
                                            class="block right-0 -bottom-[14px] absolute border-b-4 border-b-yellow-500 w-full h-1 transition-transform animate-fadein duration-500"
                                        ></div>
                                    }
                                </a>
                            }
                        </div>
                    </div>
                </div>
                <div class="hidden lg:block">
                    <div class="flex items-center ml-4 lg:ml-6">
                        <div class="relative ml-3">
                            <div class="user-dropdown-menu">
                                <a
                                    tabindex="1"
                                    class="flex items-center gap-2 px-3 py-2 rounded-md font-medium text-white lg:text-md text-sm cursor-pointer user-dropdown-menu"
                                    (click)="isMenuOpen.set(!isMenuOpen())"
                                    (keyup.enter)="isMenuOpen.set(!isMenuOpen())"
                                >
                                    <i class="material-icons user-dropdown-menu"> account_circle </i>
                                    {{ user()?.username?.toUpperCase() }}
                                    <i
                                        class="transition-transform duration-300 material-icons user-dropdown-menu"
                                        [class.rotate-180]="isMenuOpen()"
                                    >
                                        keyboard_arrow_down
                                    </i>
                                </a>
                            </div>

                            @if (isMenuOpen()) {
                                <div
                                    class="right-0 absolute bg-white shadow-lg mt-2 py-2 rounded-md ring-black/5 w-60 origin-top-right user-dropdown-menu"
                                    role="menu"
                                    aria-orientation="vertical"
                                    aria-labelledby="user-menu-button"
                                    tabindex="-1"
                                >
                                    @for (option of userOptions(); track $index) {
                                        @if (option.label === 'splitter') {
                                            <div class="my-2 border-gray-200 border-t"></div>
                                        } @else {
                                            <a
                                                class="flex items-center gap-4 hover:bg-green-400 px-4 py-2 w-full text-gray-700 text-md hover:text-white cursor-pointer user-dropdown-menu"
                                                role="menuitem"
                                                tabindex="-1"
                                                (click)="goTo(option.routerLink)"
                                                (keyup.enter)="goTo(option.routerLink)"
                                            >
                                                <i class="opacity-70 !text-xl material-icons user-dropdown-menu">{{
                                                    option.icon
                                                }}</i>
                                                {{ option.label }}
                                            </a>
                                        }
                                    }
                                    <a
                                        class="flex items-center gap-4 hover:bg-green-400 px-4 py-2 w-full text-gray-700 text-md hover:text-white cursor-pointer user-dropdown-menu"
                                        role="menuitem"
                                        tabindex="-1"
                                        (click)="logout()"
                                        (keyup.enter)="logout()"
                                    >
                                        <i class="opacity-70 !text-xl material-icons user-dropdown-menu" size="20"
                                            >input</i
                                        >
                                        Logout
                                    </a>
                                </div>
                            }
                        </div>

                        @if (isCreateButtonVisible()) {
                            <a
                                tabindex="2"
                                (click)="addDraft()"
                                (keyup.enter)="addDraft()"
                                class="mt-2 px-3 py-2 rounded-md font-medium text-md text-white cursor-pointer"
                                id="labour-sheet-add-button"
                                pTooltip="Create Labour Sheet Draft"
                                tooltipPosition="left"
                            >
                                <i class="material-icons">add_circle</i>
                            </a>
                        }
                    </div>
                </div>
                <div class="lg:hidden flex -mr-2">
                    <p-button [text]="true" (click)="isMobileMenuOpen.set(!isMobileMenuOpen())" class="cursor-pointer">
                        <i class="text-white hover:text-green-500 material-icons">menu</i>
                    </p-button>
                </div>
            </div>
        </div>

        @if (isMobileMenuOpen()) {
            <div class="lg:hidden z-[999]" id="mobile-menu">
                <div class="space-y-1 px-2 sm:px-3 pt-2 pb-3">
                    @for (option of options(); track $index) {
                        <a
                            tabindex="3"
                            class="flex items-center gap-3 hover:bg-green-700 px-3 py-2 rounded-m font-medium text-white hover:text-white text-base cursor-pointer"
                            (click)="goTo(option.routerLink)"
                            (keyup.enter)="goTo(option.routerLink)"
                        >
                            <i class="opacity-70 material-icons">{{ option.icon }}</i>
                            {{ option.label }}
                        </a>
                    }
                </div>
                <div>
                    <div class="my-2 border-green-300 border-t"></div>
                    <div class="flex items-center px-5">
                        <div class="shrink-0">
                            <i class="opacity-70 text-white material-icons">account_circle</i>
                        </div>
                        <div class="ml-3">
                            <div class="font-medium text-white text-base/5 uppercase">{{ user()?.username }}</div>
                            <div class="font-medium text-gray-400 text-sm"></div>
                        </div>
                    </div>
                    <div class="space-y-1 mt-3 px-2">
                        @for (option of userOptions(); track $index) {
                            @if (option.label === 'splitter') {
                                <div class="my-2 border-green-300 border-t"></div>
                            } @else {
                                <a
                                    class="flex items-center gap-3 hover:bg-green-700 px-3 py-2 rounded-md font-medium text-gray-200 hover:text-white text-base cursor-pointer user-dropdown-menu"
                                    role="menuitem "
                                    tabindex="-1"
                                    (click)="goTo(option.routerLink)"
                                    (keyup.enter)="goTo(option.routerLink)"
                                >
                                    <i class="opacity-70 material-icons">{{ option.icon }}</i>
                                    {{ option.label }}
                                </a>
                            }
                        }
                        <a
                            class="block hover:bg-green-700 px-3 py-2 rounded-md font-medium text-gray-200 hover:text-white text-base cursor-pointer"
                            role="menuitem"
                            tabindex="-1"
                            (click)="logout()"
                            (keyup.enter)="logout()"
                        >
                            <i class="material-icons">logout</i>
                            Log out
                        </a>
                    </div>
                </div>
            </div>
        }
    </nav>
</header>
